import TripPlanInfo from "./UI/TripPlanInfo";

export default TripPlanInfo;